import { render, staticRenderFns } from "./merchant_home.vue?vue&type=template&id=fa065b26&"
import script from "./merchant_home.vue?vue&type=script&lang=js&"
export * from "./merchant_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports